import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import { Barn, BarnModuleState } from '../../models/barn.model';
import * as barnActions from '../actions/barn.actions';

function selectIdNumber(b: Barn): number {
  return b.id;
}

function sortByName(a: Barn, b: Barn): number {
  return a.name.localeCompare(b.name);
}

export const adapter: EntityAdapter<Barn> = createEntityAdapter<Barn>({
  selectId: selectIdNumber,
  sortComparer: sortByName,
});

export const initialState = <BarnModuleState>{
  barns: adapter.getInitialState([]),
  selectedBarn: <Barn>{},
  silos: null,
  isLoaded: false,
};

const barnReducer = createReducer(
  initialState,
  on(barnActions.clearBarnState, (state) => ({
    ...state,
    selectedBarn: <Barn>{},
    barns: adapter.removeAll(state.barns),
    isLoaded: false,
  })),
  on(barnActions.loadBarnsSuccess, (state, { barns }) => ({
    ...state,
    selectedBarn: <Barn>{},
    barns: adapter.upsertMany(barns, state.barns),
    isLoaded: true,
  })),
  on(barnActions.loadBarnsFailed, (state) => ({
    ...state,
    isLoaded: true,
  })),
  on(barnActions.upsertBarnSuccess, (state, { barn }) => ({
    ...state,
    selectedBarn: barn,
    barns: adapter.upsertOne(barn, state.barns),
  })),
  on(barnActions.deleteBarnSuccess, (state, { barn }) => ({
    ...state,
    selectedBarn: <Barn>{},
    barns: adapter.removeOne(barn.id, state.barns),
  })),
  on(barnActions.upsertBarn, (state, { barn }) => ({
    ...state,
    selectedBarn: barn,
  })),
  on(barnActions.setSelectedBarn, (state, { barnId }) => ({
    ...state,
    selectedBarn:
      !!barnId && !!state.barns.entities[barnId] ? state.barns.entities[barnId] : <Barn>{},
  })),
  on(barnActions.loadSilosSuccess, (state, { silos }) => ({
    ...state,
    silos,
    isLoaded: true,
  })),
);

export function reducer(state: BarnModuleState | undefined, action: Action) {
  return barnReducer(state, action);
}
